import { render, staticRenderFns } from "./shopOrderList.vue?vue&type=template&id=6520bce8&scoped=true"
import script from "./shopOrderList.vue?vue&type=script&lang=js"
export * from "./shopOrderList.vue?vue&type=script&lang=js"
import style0 from "./shopOrderList.vue?vue&type=style&index=0&id=6520bce8&prod&lang=less&scoped=true"
import style1 from "./shopOrderList.vue?vue&type=style&index=1&id=6520bce8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6520bce8",
  null
  
)

export default component.exports